// @flow

import * as React from 'react';
import classnames from 'classnames';
import copy from 'copy-to-clipboard';
import {useLocation} from 'docs/data';
import {useActivePage} from 'docs/hooks';
import './Heading.scss';

const headings = ['h1', 'h1', 'h2', 'h3', 'h4', 'h5'];

type HeadingProps = {|
  level: number,
  children: React.Node,
  anchored?: boolean,
  id?: string,
  className?: string,
|};

export const Heading = (props: HeadingProps) => {
  const {id = '', className, children, level, anchored} = props;
  const {replaceLocation} = useLocation();
  const activePage = useActivePage();
  const tag = headings[level] || 'h1';
  const hasAnchor = anchored && id;

  const elementProps = {
    className: classnames(
      'Heading',
      hasAnchor && 'Heading--anchored',
      className,
    ),
    ...(hasAnchor
      ? {
          id,
          onClick: () => {
            replaceLocation({
              hash: `#${id}`,
              query:
                activePage.prefs.platform === 'main' ? {} : activePage.prefs,
            });
            copy(window.location.toString());
          },
        }
      : {}),
  };

  return React.createElement(tag, elementProps, children);
};
